<template>
<div>
    <app-header></app-header>
    <div class="modal" id="AddUser"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("users_adduser")}}</h5>
          </div>
          <div class="modal-body">
            <label class="label">{{caption("users_useremail")}}</label>
            <input type="text" class="input form-control" required v-model.trim="userEmail" />
            <div class="text-danger" v-if="emailEmpty">{{caption("addwin_Required")}}</div>
            <div class="mt-3">
              <span><button class="btn btn-small btn-primary" @click = "userSend()">{{caption("Submit")}}</button></span>
              <span><button class="btn btn-small btn-danger" @click = "userModalHide()">{{caption("Cancel")}}</button></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="NotFound"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("users_notfound")}}</h5>
          </div>
          <div class="modal-body">
            <label class="label">{{caption("users_notfoundtext")}}</label>
            <div class="mt-3">
              <span><button class="btn btn-small btn-danger" @click = "notFoundHide()">OK</button></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row my-3">
        
        <div class="col-lg-12 col-md-12">
        <button type="button" style="font-size: 16px" class="btn btn-outline-primary btn mr-3" @click="backToProjects()"><i class="fas fa-chevron-left mr-2"></i>{{caption("winlist_Back")}}</button>
        </div>
        </div>
        <div class="h3 mb-4 display-4">{{caption("users_sharedusers")}}</div>
        <hr>
      <button type="button" style="font-size: 20px" class="btn btn-primary btn-sm mb-2 v-step-1" @click="addUser()"><i class="fas fa-plus-square mr-2"></i>{{caption("users_adduser")}}</button>
        
        <div v-for="users in sharedusers" v-bind:key="users.Id" class="card">
        <div class="card-header">
          <div class="card-subtitle mt-1">
          <div class="row my-1">
                  <div class="col-lg-3 col-md-12">
                      <strong>{{users.firstName}} {{users.lastName}}</strong>
                  </div>
                  <div class="col-lg-3 col-md-12">
                     {{users.companyName}}
                  </div>
                  <div class="col-lg-3 col-md-12">
                      <a :href="'mailto:'+users.email">{{users.email}}</a>
                  </div>
              <div class=" col-lg-3 col-md-12 text-lg-right mx-auto">
                <span class="btn btn-sm btn-outline-danger v-step-9" @click="deleteuser(users.userId)"><i class="fas fa-trash-alt" ></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      error: null,
      sharedusersloaded: false,
      userEmail: null,
      emailEmpty: true
    };
  },
  components: {
    AppHeader
  },
  computed: {
      sharedusers(){
        var u = this.$store.state.sharedusers;
        return u;
      },
      lang(){
        var l = this.$store.getters.getLanguage;
        return l;
      },
      projEmpty(){
        if (this.emailEmpty) return true
        else return false
      },
      ...mapGetters(['getSysco', 'getVNList'])
  },
  methods:{
      backToProjects(){
        this.$router.push("/projects/0");
      },
      caption(term){
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
      },
      addUser(){
        $('#AddUser').modal('show');
      },
      deleteuser(payload){
        this.$store.dispatch("deleteUser", payload)
        .then(response => {
            this.$store.dispatch("getSharedUsers");
        })
      },
      userModalHide(){
        $('#AddUser').modal('hide');
      },
      notFoundHide(){
        $('#NotFound').modal('hide');
      },
      userSend(){
        if (this.userEmail != ""){
        $('#AddUser').modal('hide');
        var payload = this.userEmail;
        this.$store.dispatch("getUser", payload)
        .then(response => {
            this.$store.dispatch("getSharedUsers");
        })
        .catch (error => {
          $('#NotFound').modal('show');
        });
        } else {
          this.emailEmpty = true;
        }
      }
  },
  
  mounted() {
    this.$store.dispatch("getSharedUsers")
    .then(response => {
      this.sharedusersloaded = true;
    });
  },
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    

    .lnk{
      cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/users/SharedUserList.vue